import React from "react";
import cx from "classnames";
import PropTypes from "prop-types";
import DeleteItem from "rialto-icons/DeleteItem";
import Executed from "rialto-icons/Executed";

import Translate from "utils/translate";

import styles from "./DealStatusMessage.css";

const { t } = new Translate("EnquiryStatusMessage");

const DealStatusMessage = ({ actor, children, isExecuted, subtitle }) => {
  const status = isExecuted ? t("executed") : t("disregarded");
  const message =
    actor && !actor.deleted
      ? t("message", { status, actor: `${actor.fname} ${actor.lname}` })
      : t("message_no_actor", { status });

  return (
    <div className={styles.root}>
      <div className={styles.container}>
        <div className={cx(styles.icon, { [styles.green]: isExecuted })}>
          {isExecuted ? <Executed size="xlarge" /> : <DeleteItem size="xlarge" />}
        </div>
        <div className={styles.details}>
          <div className={styles.title} dangerouslySetInnerHTML={{ __html: message }} />
          <div className={styles.subtitle}>{subtitle}</div>
          <div className={styles.content}>{children}</div>
        </div>
      </div>
    </div>
  );
};

DealStatusMessage.propTypes = {
  actor: PropTypes.shape({
    id: PropTypes.number.isRequired,
    fullName: PropTypes.string,
  }),
  subtitle: PropTypes.node,
  children: PropTypes.node,
  isExecuted: PropTypes.bool,
};

export default DealStatusMessage;
